import { formatDateWithTime } from '../../helper';
import { InvoiceObject } from '../../params/redux/product';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { brand, gray, green, orange, red } from '../../theme/themePrimitives';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

interface CustomersRow {
    id: number;
    product: string;
    datetime: string;
    amount: string;
    status: 'paid' | 'unpaid' | 'draft' | 'cancelled';
}

const InvoicesTable = () => {
    const { invoices, loaders } = useSelector((state: RootState) => state.product);
    const rows: CustomersRow[] = invoices.map((invoice: InvoiceObject) => ({
        id: invoice.id || 0,
        product: invoice.customer_email,
        datetime: invoice.created_at,
        amount: invoice.amount,
        status: invoice.status
    })) || [];
    const columns: GridColDef<CustomersRow>[] = [
        {
            field: 'product',
            headerName: 'PRODUCT',
            flex: 1,
            renderCell: (params: GridRenderCellParams<CustomersRow, string>) => <Box display="flex" gap="10px" alignItems="center" my={1}>
                <Typography variant="subtitle1" fontWeight="bold" color="textSecondary">{params.value}</Typography>
            </Box>
        },
        {
            field: 'datetime',
            headerName: 'DATE & TIME',
            flex: 1,
            renderCell: (params: GridRenderCellParams<CustomersRow, string>) => <Box display="flex" gap="10px" alignItems="center" my={1}>
                <Typography variant="subtitle1" color="textSecondary">{params.value && formatDateWithTime(params.value)}</Typography>
            </Box>
        },
        {
            field: 'amount',
            headerName: 'AMOUNT',
            flex: 1,
            renderCell: (params: GridRenderCellParams<CustomersRow, string>) => <Box display="flex" gap="10px" alignItems="center" my={1}>
                <Typography variant="subtitle1" color="textSecondary">USD ${params.value && params.value}</Typography>
            </Box>
        },
        {
            field: 'status',
            headerName: 'STATUS',
            flex: 1,
            renderCell: (params: GridRenderCellParams<CustomersRow, 'paid' | 'unpaid' | 'draft' | 'cancelled'>) => <Box display="flex" alignItems="center" gap="2px">
                <Box
                    p={1}
                    mt={1}
                    height="max-content"
                    borderRadius={1}
                    bgcolor={params.value === 'draft' ? gray[100] : params.value === 'cancelled' ? red[100] : params.value === 'unpaid' ? orange[100] : green[100]}
                    color={params.value === 'draft' ? gray[400] : params.value === 'cancelled' ? red[400] : params.value === 'unpaid' ? orange[400] : green[400]}
                >
                    <Typography variant="body2" fontWeight="bold">{params.value?.toLocaleUpperCase()}</Typography>
                </Box>
            </Box>
        }
    ];
    return <Box height="40vh" width="100%" mt={2}>
        <DataGrid
            rows={rows as CustomersRow[]}
            loading={loaders.isLoading}
            columns={columns}
            pagination
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 20
                    }
                }
            }}
            sx={{
                '& .MuiDataGrid-row--borderBottom': {
                    backgroundColor: `${brand[50]} !important`
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 'bold'
                },
                '& .MuiDataGrid-columnHeaders': {
                    fontWeight: 'bold'
                },
                '& .MuiDataGrid-cell': {
                    fontSize: '14px'
                },
                'width': '100%',
                'overflowX': 'hidden'
            }}
        />
    </Box>;
};

export default InvoicesTable;